import type { SessionResponse } from '@chatapp-inbox/shared';
import { createContext, useContext } from 'react';
import type { EndReason } from './flags-store';
import type { SessionState } from './session';

/** O que o resto da pasta `auth` usa; o app de fora só enxerga `useSession`/`useLogout`. */
export interface AuthContextValue {
  state: SessionState;
  /** Distingue "saí" de "expirou" na hora de decidir destino e aviso da tela de entrada. */
  endReason: EndReason | null;
  logoutStatus: { pending: boolean; error: string | null };
  /** Registra um login bem-sucedido (já feito em `api/login`) trocando o cache inteiro. */
  signedIn: (session: SessionResponse) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuthContext(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error('Este componente precisa estar dentro de <AuthProvider>.');
  return value;
}

/** Situação da sessão: carregando, conectado, desconectado ou sem conseguir perguntar ao servidor. */
export function useSession(): SessionState {
  return useAuthContext().state;
}
